module.exports = __webpack_public_path__ + "img/compare_icon_file.219236ee.png";